import React from "react"
import { injectIntl} from "react-intl"

type OwnProps = {
    countryCode: string
    postalCode:string
    onChange: () => void
    placeholder: string
    name:string
    id:string
    type:string
    className:string
    required:boolean
}

const PostalCodeInput = (props: OwnProps) => {
    //let regex=props.countryCode &&
    // GlobalHelper.getPostalCodeValidationString(props.countryCode) ?
    // GlobalHelper.getPostalCodeValidationString(props.countryCode).source:/^.*$/.source
    return (
        <>
            <input
                name={props.name}
                value={props.postalCode}
                onChange={props.onChange}
                //pattern={regex}
                id={props.id}
                type={props.type}
                className={props.className}
                placeholder={props.placeholder}
            />
        </>
    )

}

export default injectIntl(PostalCodeInput)



// WEBPACK FOOTER //
// ./src/common/inputs/PostalCodeInputComponent.tsx